// Los valores reales de este archivo se inyectan en build-time desde Infisical
// (entorno "dev") por el pipeline CI/CD. Ver docs/infisical-migration-plan.md
// en el repo ci-templates. Para desarrollo local usar environment.local.ts.
export const environment = {
  production: false,
  loginEncryptionTarget: 'dev' as const,
  apiEndpoint: 'https://api.smartsupport.devonlineassist.me/',
  //apiEndpoint: 'https://api-eli.smartsupport.devonlineassist.me/',

  provisionEndpoint: 'https://api-provision.smartsupport.devonlineassist.me/',
  host: '.smartsupport.devonlineassist.me',
  pwaManifest: 'https://devstatic.app.onlineassist.me/suite/json/pwa-manifest.json',
  fractelPath: 'res/download/fractel/dev/',
  translatePath: 'https://devstatic.app.onlineassist.me/suite/i18n/',
  FB_APP_ID: '818925648718306',
  GOOGLE_APP_ID: '1029241894559-one04bug77k0dlg3a855l3hrm8ehl6s9.apps.googleusercontent.com',
  STATIC_CONTENT: 'https://devstatic.app.onlineassist.me/suite/',
  STATIC_SERVER: 'https://devstatic.app.onlineassist.me/',
  firebaseConfig: {
    apiKey: 'AIzaSyDMt3pvMhhHx2Mt6fMweLLn_LkkKw7fsTo',
    authDomain: 'corenotifications-3afc9.firebaseapp.com',
    projectId: 'corenotifications-3afc9',
    storageBucket: 'corenotifications-3afc9.appspot.com',
    messagingSenderId: '1063623040416',
    appId: '1:1063623040416:web:7cac9fdc698a2ece0c58c5',
    measurementId: 'G-ZWVYSJQJ68',
  },
  turnstile: {
    url: 'https://challenges.cloudflare.com/turnstile/v0/',
    siteKey: '0x4AAAAAABC3JKVJmtOoptUw',
    secret: '0x4AAAAAABC3JME5YbXtvMd2dImcnqMQOus',
  },
  apiWebSocket: 'wss://api-websocket.smartsupport.devonlineassist.me/',
  mockSocActivationState: null as number | null,
  cybersocDesignPreviewInlineTranslations: true,
  suiteMfBmsRemoteEntry: 'https://suite.smartsupport.devonlineassist.me/bms/remoteEntry.json',
  suiteMfAapRemoteEntry: 'https://suite.smartsupport.devonlineassist.me/aap/remoteEntry.json',
  suiteMfMcfRemoteEntry: 'https://suite.smartsupport.devonlineassist.me/mcf/remoteEntry.json',
  suiteMfDfkRemoteEntry: 'INFISICAL_PENDING',
  suiteMfForRemoteEntry: 'https://suite.smartsupport.devonlineassist.me/for/remoteEntry.json',
  suiteMfVpcRemoteEntry: 'https://suite.smartsupport.devonlineassist.me/vpc/remoteEntry.json',
};
